import { render, staticRenderFns } from "./FixedRentalCampaignName.vue?vue&type=template&id=61d625f2"
import script from "./FixedRentalCampaignName.vue?vue&type=script&lang=js"
export * from "./FixedRentalCampaignName.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports